import React from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import "../styles/HomePageStyles/progress.css";
import { Progress } from "reactstrap";
import p2 from "../assets/products/waffesls2.png";
import p1 from "../assets/products/popping.png";
import OrderBtn from "../utils/OrderBtn";
import config from "../config";

const ProgressSection = ({
  make_title,
  make_description,
  make_satisfied_customers,
  make_organic_ingredients,
  make_organic_skilled_icecream_artist,
  make_image1,
  make_image1_name,
  make_image2,
  make_image2_name,
}) => {
  Aos.init({
    offset: 0,
    duration: 1000,
    once: true,
    easing: "ease-out-cubic",
    disable: "phone",
  });

 

  return (
    <div className="progress-container-wrapper">
      <div className="progress-container-top"></div>

      <div className="progress-container">
        <div className="progress_left" data-aos="zoom-out">
          {make_title && make_title !== "-" ? (
            <h2 data-aos="zoom-out">{make_title}</h2>
          ) : (
            <h2 data-aos="zoom-out">Make Every Occasion Sweet and Special</h2>
          )}
          {make_description && make_description !== "-" ? (
            <p data-aos="zoom-out">{make_description}</p>
          ) : (
            <p data-aos="zoom-out">
              At Rollz Ice Cream, every celebration deserves a scoop of joy.
              Whether it's a birthday, festival, or just a sweet craving, we
              make every moment memorable with our freshly rolled ice cream,
              milkshakes, and more. Indulge in the perfect treat made just for
              you!
            </p>
          )}

          <div className="gap-2 progressbar_container">
            <div className="progressbar" data-aos="zoom-out">
              <h5>Satisfied Customers</h5>
              <Progress
                style={{ color: "var(--heading-color)" }}
                // now={make_satisfied_customers || 0}
                value={`${make_satisfied_customers.slice(0, 3)}`}
              ></Progress>
              <p className="percentage">
                {`${make_satisfied_customers}%` || "NA"}
              </p>
            </div>
            <div className="progressbar" data-aos="zoom-out">
              <h5>Organic Ingredients</h5>
              <Progress
                style={{
                  color: "var(--heading-color)",
                }}
                value={make_organic_ingredients.slice(0, 3)}
              ></Progress>
              <p className="percentage">
                {`${make_organic_ingredients}%` || "NA"}
              </p>
            </div>
            <div className="progressbar" data-aos="zoom-out">
              <h5>Skilled Ice Cream Artists</h5>
              <Progress
                style={{ color: "var(--heading-color)" }}
                value={make_organic_skilled_icecream_artist.slice(0, 3)}
              ></Progress>
              <p className="percentage">
                {" "}
                {`${make_organic_skilled_icecream_artist}%` || "NA"}{" "}
              </p>
            </div>
          </div>

          <div className="progress_btn" data-aos="zoom-out">
            {/* <button className="order-online">
              <div className="order-online-trans-1"></div>
              <div  className="order-online-trans-2"></div>
              Shop Now
            </button> */}

            <OrderBtn text={"Visit Our Nearest Location"} url={`${config.appUrl}/${localStorage.getItem('location_name')?.toLowerCase()?.replaceAll(",","")?.replaceAll(" ","-")}`} />
          </div>
        </div>

        <div className="progress_right" data-aos="zoom-out">
          <div className="progress_right_container">
            <div className="donut_card progress_right_img_cont">
              <img
                src={make_image1 || p2}
                alt="waffles"
                className="img-fluid waffles"
              />
              {make_image1_name && make_image1_name !== "-" ? (
                <h5>{make_image1_name}</h5>
              ) : (
                <h5>Belgian Waffle</h5>
              )}
            </div>
            <div className="icecream_card progress_right_img_cont">
              <img
                src={make_image2 || p1}
                alt="Popping Soda"
                className="img-fluid popping_soda"
              />
              {make_image2_name && make_image2_name !== "-" ? (
                <h5>{make_image2_name}</h5>
              ) : (
                <h5>Popping Soda</h5>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <div className="progress-container-bottom"></div> */}
    </div>
  );
};

export default ProgressSection;
